import React, { useState } from "react";
import "./AnnouncementForm.css";

const AnnouncementForm = () => {
  const [announcement, setAnnouncement] = useState({
    title: "",
    date: "",
    introduction: "",
    details: "",
    callToAction: "",
    contactInfo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnnouncement((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Send data to PHP backend
    fetch("http://localhost/eac_backend/submit-announcement.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(announcement),
    })
      .then((response) => response.json())
      .then((data) => {
        alert("Announcement submitted successfully!");
        setAnnouncement({
          title: "",
          date: "",
          introduction: "",
          details: "",
          callToAction: "",
          contactInfo: "",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("An error occurred. Please try again.");
      });
  };

  return (
    <div className="announcement-form-container">
      <h2>Create an Announcement</h2>
      <form onSubmit={handleSubmit} className="announcement-form">
        <label>
          Title:
          <input
            type="text"
            name="title"
            value={announcement.title}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Date:
          <input
            type="date"
            name="date"
            value={announcement.date}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Introduction:
          <textarea
            name="introduction"
            value={announcement.introduction}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Details:
          <textarea
            name="details"
            value={announcement.details}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Call to Action:
          <input
            type="text"
            name="callToAction"
            value={announcement.callToAction}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Contact Information:
          <input
            type="text"
            name="contactInfo"
            value={announcement.contactInfo}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit" className="submit-btn">
          Submit Announcement
        </button>
      </form>
    </div>
  );
};

export default AnnouncementForm;
